import i18next from 'i18next'
import React, { useEffect, useState } from 'react'
import { navigate } from 'widgets-for-react'

export function KnowledgeSearchBlock(props: {
  query: string
  page: number
  disabled?: boolean
}) {
  // @todo: Move to global state
  const [query, setQuery] = useState(props.query)
  const location = window.location

  // @todo: get rid of useeffect
  useEffect(() => {
    setQuery(props.query)
  }, [props.query])

  const onFormSubmit: React.FormEventHandler<HTMLFormElement> = e => {
    e.preventDefault()
    navigate(
      `${location.pathname}?${new URLSearchParams({
        page: '1',
        search: query
      }).toString()}`
    )
  }

  return (
    <section className="block block--search">
      <div className="block__inner container--s spacing--m gutter--m">
        <header className="block__header">
          <h2 className="block__title title--m">
            {i18next.t('search:searchInKnowledge')}
          </h2>
        </header>

        <div className="block__content">
          <div className="blockform blockform--search">
            <div className="blockform__inner">
              <form onSubmit={onFormSubmit}>
                <label className="sr-text" htmlFor="a11y-sg-search">
                  {i18next.t('search:label')}
                </label>
                <input
                  className="blockform__input"
                  id="a11y-sg-search"
                  name="sg-search"
                  type="search"
                  placeholder={i18next.t('search:placeholderKnowledge')}
                  value={query}
                  onChange={e => setQuery(e.target.value)}
                  disabled={props.disabled}
                />
                <button
                  disabled={props.disabled}
                  type="submit"
                  className="blockform__button button button--primary button--icon"
                >
                  <span className="button__label">
                    {i18next.t('search:search')}
                  </span>
                  <svg className="button__icon" width="18px" height="18px">
                    <use xlinkHref="#icon--search" />
                  </svg>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
